module.exports = __webpack_public_path__ + "img/sld_mfm_ic_4_t1_b1_dark.00df1a0d.svg";